import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Modal, PageHead, useToast } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

type Info = { _id: string; name?: string; [key: string]: unknown }

export function SubMarketInfoPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const [list, setList] = useState<Info[]>([])
  const [deleteId, setDeleteId] = useState<string | null>(null)

  const load = () => {
    void sessionApi.getAllSubMarketInfo().then((res) => {
      setList(Array.isArray(res.data) ? (res.data as Info[]) : [])
    })
  }

  useEffect(() => {
    load()
  }, [])

  return (
    <div>
      <PageHead
        title="Sub Market Info"
        onBack={() => navigate('/sessionmarket')}
        actions={
          <Link to="/createsubmarketinfo">
            <Button variant="primary">Create</Button>
          </Link>
        }
      />
      <div className="sm-card">
        <table className="w7-table">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {list.map((row, i) => (
              <tr key={row._id}>
                <td>{i + 1}</td>
                <td>{String(row.name ?? '')}</td>
                <td className="sm-row">
                  <Link to={`/createsubmarketinfo?id=${row._id}`}>
                    <Button size="sm">Edit</Button>
                  </Link>
                  <Button size="sm" variant="danger" onClick={() => setDeleteId(row._id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        open={!!deleteId}
        onClose={() => setDeleteId(null)}
        title="Delete"
        footer={
          <Button
            variant="danger"
            onClick={() => {
              if (!deleteId) return
              void sessionApi.deleteOneSubMarketInfo(deleteId).then(() => {
                toast.success('Deleted')
                setDeleteId(null)
                load()
              })
            }}
          >
            Delete
          </Button>
        }
      >
        <p>Delete this entry?</p>
      </Modal>
    </div>
  )
}
